export default "__VITE_ASSET__f3329425__"